import { INTEGRATIONS } from './catalog'
import type { Integration } from './types'

const ALPHANUMERIC = /[\p{L}\p{N}]/u

/**
 * A prefix only identifies a product when the name stops using it as a word, so
 * a name that continues the prefix into a longer word is not a match.
 */
function startsWithPrefix(lowercasedName: string, prefix: string): boolean {
  if (!lowercasedName.startsWith(prefix)) {
    return false
  }

  const characterAfterPrefix = lowercasedName[prefix.length]

  return (
    characterAfterPrefix === undefined ||
    !ALPHANUMERIC.test(characterAfterPrefix)
  )
}

/**
 * Finds the integration a connected client's self-reported name belongs to.
 *
 * The name is free text the client picks at registration, so it is matched by
 * prefix: an integration claims the names that start with it, not every name
 * that mentions it somewhere.
 */
export function matchClientName(name: string): Integration | null {
  const lowercasedName = name.toLowerCase()

  return (
    INTEGRATIONS.find((integration) =>
      integration.clientNamePrefixes.some((prefix) =>
        startsWithPrefix(lowercasedName, prefix),
      ),
    ) ?? null
  )
}
